var normalizeComponent = require("!../../../../vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../vux-loader/src/script-loader.js!../../../../vux-loader/src/script-loader.js!../../../../vue-loader/lib/selector?type=script&index=0!./swipeout-button.vue"
import __vue_script__ from "!!babel-loader!../../../../vux-loader/src/script-loader.js!../../../../vue-loader/lib/selector?type=script&index=0!./swipeout-button.vue"
/* template */
import __vue_template__ from "!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-15070d5b\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../vux-loader/src/before-template-compiler-loader.js!../../../../vux-loader/src/template-loader.js!../../../../vue-loader/lib/selector?type=template&index=0!./swipeout-button.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vux/src/components/swipeout/swipeout-button.vue
// module id = 36
// module chunks = 46